import(/* webpackMode: "eager" */ "/vercel/path0/blockpage411/app/search/error.tsx");
